import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import axios from 'axios';
import { API_BASE_URL } from '../../config/api';
import { useAuth } from '../../contexts/AuthContext';
import { showSuccess, showError } from '../../utils/toast';

interface LogoutButtonProps {
  className?: string;
  showText?: boolean;
  onLogoutSuccess?: () => void;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  className = '', 
  showText = true,
  onLogoutSuccess 
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { logout: authLogout } = useAuth();

  const handleLogout = async () => {
    setIsLoading(true);
    
    try {
      // Show success message before logout
      showSuccess('جاري تسجيل الخروج...');
      
      // Call callback if provided
      if (onLogoutSuccess) {
        onLogoutSuccess();
      }
      
      // Use unified logout from AuthContext (handles API call, clearing storage, and redirect)
      await authLogout();
      
    } catch (error) {
      console.error('Logout error:', error);
      showError('حدث خطأ أثناء تسجيل الخروج');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoading}
      className={`flex items-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      <LogOut className="w-5 h-5" />
      {showText && (
        <span className="font-medium">
          {isLoading ? 'جاري تسجيل الخروج...' : 'تسجيل الخروج'}
        </span>
      )}
    </button>
  );
};

export default LogoutButton;